function showOpenPriceProductModal(productButton) {
  const productId = productButton
    .closest('.shop-product-container')
    .attr('data-product-id');

  return $.ajax({
    type: 'POST',
    url: '/api/v1/private/products/get-open-price-product-modal',
    data: { product_id: productId },
  })
    .done(function (data) {
      if (data.html) {
        $('#open-price-modal').remove();
        $('#content').append(data.html);
        $('#open-price-modal')
          .data('product-button', productButton)
          .modal('show');
      }
    })
    .fail(function (data) {
      if (data.responseJSON) {
        showToast({
          type: 'error',
          message: data.responseJSON,
          position: 'bottom-center',
        });
      }
    });
}

$(document).ready(function () {
  $(document).on('shown.bs.modal', '#open-price-modal', function () {
    $('#open-price-modal-input').trigger('focus');
  });

  $(document).on('hidden.bs.modal', '#open-price-modal', function () {
    $(this).remove();
  });

  $(document).on('click', '#open-price-modal-confirm', function () {
    const modal = $('#open-price-modal');

    // Ignore a second Enter while the modal is already closing
    if (!modal.hasClass('show')) {
      return;
    }

    const input = $('#open-price-modal-input');
    const productButton = modal.data('product-button');
    const price = parseFloat(input.val().replace(',', '.'));

    if (isNaN(price) || price < 0) {
      input.addClass('is-invalid');
      $('#open-price-modal-feedback').removeClass('d-none');
      return;
    }

    // Set the entered price on the button's data attributes for use in the add logic
    productButton.attr('data-price-incl-vat', price.toFixed(2));
    productButton.attr('data-alter-price-incl-vat', price.toFixed(2));

    // Temporarily disable the open-price flag to bypass the modal check in the click handler
    const productContainer = productButton.closest('.shop-product-container');
    const originalOpenPriceFlag = productContainer.attr('data-is-open-price');
    productContainer.attr('data-is-open-price', 0);

    $('#openPriceValue').text(price.toFixed(2));
    modal.modal('hide');

    productButton.click();

    productContainer.attr('data-is-open-price', originalOpenPriceFlag);
  });

  $(document).on('input', '#open-price-modal-input', function () {
    $(this).removeClass('is-invalid');
    $('#open-price-modal-feedback').addClass('d-none');
  });
});
